module.exports = __webpack_public_path__ + "static/media/dstays2.46c9e478.png";